import { DestinationRateLimitPeriod } from '../../../../typings/Destination.interface';

export const rateLimitToSeconds = (
  rateLimit: number,
  rateLimitPeriod: DestinationRateLimitPeriod,
) => {
  switch (rateLimitPeriod) {
    case 'hour':
      return rateLimit / 3600;
    case 'minute':
      return rateLimit / 60;
    case 'second':
      return rateLimit;
    case 'concurrent':
      return rateLimit;
  }
};
